export const distinctivenessColorMap = {
  'V.High': '#b5f4b7',
  High: '#e9f4b5',
  Moderate: '#ffff8a',
  Low: '#ffd98a',
  'V.Low': '#ffb38a',
};
